module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block height"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('ul', {
    staticClass: "button list"
  }, [(_vm.opgeschort === 'N' && _vm.camperverhuur === 'J') ? _c('form', {
    attrs: {
      "action": _vm.ctx + '/camperverhuuraanvragen.html',
      "method": "post"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.csrftokenname
    },
    domProps: {
      "value": _vm.csrftokenvalue
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "polVolg"
    },
    domProps: {
      "value": _vm.polVolg
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "polVolgSub"
    },
    domProps: {
      "value": _vm.polVolgSub
    }
  }), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.opgeschort === 'N') ? _c('form', {
    attrs: {
      "action": _vm.ctx + '/schademelden.html?polisid=' + _vm.poliswijzigid,
      "method": "post"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.csrftokenname
    },
    domProps: {
      "value": _vm.csrftokenvalue
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "poliswijzigid"
    },
    domProps: {
      "value": _vm.poliswijzigid
    }
  }), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.opgeschort === 'N') ? _c('form', {
    attrs: {
      "action": _vm.ctx + '/wijzigpolis.html?polisid=' + _vm.poliswijzigid,
      "method": "post"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.csrftokenname
    },
    domProps: {
      "value": _vm.csrftokenvalue
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "poliswijzigid"
    },
    domProps: {
      "value": _vm.poliswijzigid
    }
  }), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.opgeschort === 'N') ? _c('form', {
    attrs: {
      "action": _vm.ctx + '/wijzigpolis.html?polisid=' + _vm.poliswijzigid,
      "method": "post"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.csrftokenname
    },
    domProps: {
      "value": _vm.csrftokenvalue
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "poliswijzigid"
    },
    domProps: {
      "value": _vm.poliswijzigid
    }
  }), _vm._v(" "), _vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.groenekaart === 'J' && _vm.opgeschort === 'N') ? _c('li', [_c('a', {
    staticClass: "btn btn-primary btn-arrow",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#groenekaartmodal"
    }
  }, [_vm._v("Groene kaart aanvragen")])]) : _vm._e(), _vm._v(" "), (_vm.groenekaart === 'A' && _vm.opgeschort === 'N') ? _c('li', [_vm._m(5)]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn btn-primary btn-arrow",
    attrs: {
      "href": _vm.ctx + '/serviceencontact.html'
    }
  }, [_vm._v("Hulp nodig?")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "groenekaartmodal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Wanneer u recent een nieuwe verzekering heeft afgesloten, ontvangt u binnenkort automatisch de groene kaart. ")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": _vm.ctx + '/aanvragen-groenekaart',
      "method": "post"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "polisid"
    },
    domProps: {
      "value": _vm.poliswijzigid
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "groenekaartId"
    },
    domProps: {
      "value": _vm.groenekaartid
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.csrftokenname
    },
    domProps: {
      "value": _vm.csrftokenvalue
    }
  }), _vm._v(" "), _c('span', [_vm._v("Geldt deze situatie niet voor u?")]), _vm._v(" "), _c('button', {
    staticClass: "button-as-link",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Ga door met aanvragen")]), _vm._v(".\n\t\t\t\t\t")])]), _vm._v(" "), _vm._m(7)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_c('span', [_vm._v("Direct...")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('button', {
    staticClass: "btn btn-primary btn-arrow",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Camper verhuur")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('button', {
    staticClass: "btn btn-primary btn-arrow",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Schade melden")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('button', {
    staticClass: "btn btn-primary btn-arrow",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Wijziging doorgeven")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('button', {
    staticClass: "btn btn-primary btn-arrow",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Opzeggen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "alert alert-success"
  }, [_c('span', {
    staticClass: "icon clean"
  }, [_c('span', {
    staticClass: "icon-check"
  })]), _vm._v("  Groene kaart aangevraagd\n\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Groene kaart aanvragen")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-modal-close",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Annuleren")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ac07fe8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/polisdetails/directlinks.vue
// module id = 56
// module chunks = 0